import React from "react";
import { Icon, Flex, Text, BoxProps, VStack } from "@chakra-ui/react";
import {
  CheckCircle,
  XCircle,
  PauseCircle,
  PieChart,
  AlertCircle,
  XSquare,
} from "react-feather";
import { useTranslation } from "next-i18next";

import { AccreditationTypes } from "@/types/accreditation";
import { getAccreditationStatusColor } from "@/utils/accreditation";
import WithdrawAccreditationButton from "@/components/common/WithdrawAccreditationButton";

type Props = {
  status: AccreditationTypes;
  accreditationId: number;
  eventId: number;
};

const AccreditationStatus = ({
  status,
  accreditationId,
  eventId,
  ...props
}: Props & BoxProps): React.ReactElement => {
  const { t } = useTranslation("common");
  let icon = null;

  if (status === AccreditationTypes.PENDING) icon = PauseCircle;
  if (status === AccreditationTypes.GRANTED) icon = CheckCircle;
  if (status === AccreditationTypes.INCOMPLETE) icon = PieChart;
  if (status === AccreditationTypes.CANCELED) icon = AlertCircle;
  if (status === AccreditationTypes.REJECTED) icon = XCircle;
  if (status === AccreditationTypes.WITHDRAWN) icon = XSquare;

  return (
    <VStack
      w="100%"
      position={{ base: "unset", md: "sticky" }}
      top={1}
      zIndex={100}
      spacing={4}
      py={4}
    >
      <Flex
        bgColor={getAccreditationStatusColor(status)}
        color="white"
        align="center"
        justifyContent={"center"}
        rounded={"xl"}
        height={{ base: "auto", md: 50 }}
        width="100%"
        p={{ base: 0, md: 4 }}
        pt={{ base: 0, md: "1.25rem" }}
        mt={{ base: 0, md: "-1.25rem" }}
        gap={{ base: 2, md: 0 }}
        flexDirection={{ base: "column", md: "row" }}
        py={{ base: 2, md: 0 }}
        {...props}
      >
        <Icon as={icon} w={8} h={8} mr={3} />
        <Text fontSize={"2xl"} fontWeight="bold" letterSpacing={1}>
          {t(`events.statusInfo.${status}`)}
        </Text>

        <WithdrawAccreditationButton
          status={status}
          accreditationId={accreditationId}
          eventId={eventId}
          ml={{ base: 0, md: 8 }}
          maxW={{ base: "70%", md: "100%" }}
          p={2}
        />
      </Flex>
    </VStack>
  );
};

export default AccreditationStatus;
